<template>
  <BaseCard :card-name="tr('Patient Schedule')" :spinnerOn="false">
    <AddPatient @open-find-patient-modal="$emit('open-find-patient-modal')" @form-change="$emit('form-change')"
      @reset-confirmation="$emit('reset-confirmation')" />
    <div>
      <PatientToBeScheduled @form-change="$emit('form-change')" @reset-confirmation="$emit('reset-confirmation')" />
    </div>
    <div>
      <ScheduledPatient @reset-confirmation="$emit('reset-confirmation')"/>
    </div>
  </BaseCard>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { defineEmits, onMounted, ref } from 'vue'
import BaseCard from '@/ux3/cards/BaseCard/BaseCard.vue'
import { useStore } from 'vuex'
import { getScheduleAPI } from '@/ux3/cards/TumorBoardSideBar/getScheduleAPI'
import AddPatient from './AddPatient.vue'
import PatientToBeScheduled from './PatientToBeScheduled.vue'
import ScheduledPatient from './ScheduledPatient'

defineEmits('open-find-patient-modal', 'form-change', 'reset-confirmation')
const tr = (x) => x // inject('tr')
const store = useStore()
const schedulePatients = ref([])

onMounted(async () => {
  //Instead of calling scheduledPtaients API, call generic which serves both scheduled and notscheduled, then do manipulation
  const schedulePatientFromResponse = await getScheduleAPI()
  schedulePatients.value = schedulePatientFromResponse
  store.dispatch('setScheduledAndToBeScheduledPatients', { schedulePatients: schedulePatientFromResponse, publish: true })
})
</script>

<style>
.heading {
  display: flex;
  align-items: flex-start;
}
</style>

